const dict = {
  getContractStatus: function(s) {
    return s == "-1"
      ? "待修改"
      : s == 0
        ? "待审核"
        : s == 1
          ? "待签章"
          : s == 2
            ? "签章中"
            : s == 3
              ? "已签章"
              : s == 4
                ? "已归档"
                : s == 5
                  ? "已撤销"
                  : s == 7
                    ? "已作废"
                    : "";
  }
};

const state = {
  "-1": "编辑中",
  "0": "待审核",
  "1": "待签章",
  "10": "待设置",
  "2": "签章中",
  "3": "已签章",
  "4": "已归档",
  "5": "已撤销",
  "6": "作废中",
  "7": "已作废",
  "8": "审核不通过",
  "9": "审核中",
  "11": "物理印章签章中",
  "12": "物理印章已签章"
};

const check = {
  //判断银行卡
  isBankCard: function(str_cardNo) {
    str_cardNo = str_cardNo || String(this);
    if ("" == str_cardNo.trim() || undefined == str_cardNo) {
      return false;
    }
    var lastNum = str_cardNo.substr(str_cardNo.length - 1, 1); //取出最后一位（与luhm进行比较）

    var first15Num = str_cardNo.substr(0, str_cardNo.length - 1); //前15或18位
    var newArr = new Array();
    for (var i = first15Num.length - 1; i > -1; i--) {
      //前15或18位倒序存进数组
      newArr.push(first15Num.substr(i, 1));
    }
    var arrJiShu = new Array(); //奇数位*2的积 <9
    var arrJiShu2 = new Array(); //奇数位*2的积 >9

    var arrOuShu = new Array(); //偶数位数组
    for (var j = 0; j < newArr.length; j++) {
      if ((j + 1) % 2 == 1) {
        //奇数位
        if (parseInt(newArr[j]) * 2 < 9) arrJiShu.push(parseInt(newArr[j]) * 2);
        else arrJiShu2.push(parseInt(newArr[j]) * 2);
      } //偶数位
      else arrOuShu.push(newArr[j]);
    }

    var jishu_child1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
    var jishu_child2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
    for (var h = 0; h < arrJiShu2.length; h++) {
      jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
      jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
    }

    var sumJiShu = 0; //奇数位*2 < 9 的数组之和
    var sumOuShu = 0; //偶数位数组之和
    var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
    var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
    var sumTotal = 0;
    for (var m = 0; m < arrJiShu.length; m++) {
      sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
    }

    for (var n = 0; n < arrOuShu.length; n++) {
      sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
    }

    for (var p = 0; p < jishu_child1.length; p++) {
      sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
      sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
    }
    //计算总和
    sumTotal =
      parseInt(sumJiShu) +
      parseInt(sumOuShu) +
      parseInt(sumJiShuChild1) +
      parseInt(sumJiShuChild2);

    //计算Luhm值
    var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
    var luhm = 10 - k;

    if (lastNum == luhm) {
      return true;
    } else {
      return false;
    }
  },
  //判断身份证
  isIdCard: function(str_idCard, sex) {
    str_idCard = str_idCard || String(this);
    var check = function() {
      var factorArr = new Array(
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1,
        6,
        3,
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1
      );
      var parityBit = new Array(
        "1",
        "0",
        "X",
        "9",
        "8",
        "7",
        "6",
        "5",
        "4",
        "3",
        "2"
      );
      var varArray = new Array();
      var lngProduct = 0;
      var intCheckDigit;
      var intStrLen = str_idCard.length;
      var idNumber = str_idCard;
      // initialize
      if (intStrLen != 15 && intStrLen != 18) {
        return false;
      }
      // check and set value
      for (let i = 0; i < intStrLen; i++) {
        varArray[i] = idNumber.charAt(i);
        if ((varArray[i] < "0" || varArray[i] > "9") && i != 17) {
          return false;
        } else if (i < 17) {
          varArray[i] = varArray[i] * factorArr[i];
        }
      }

      if (intStrLen == 18) {
        //check date
        var date8 = idNumber.substring(6, 14);

        if (!/^[0-9]{8}$/.test(date8)) {
          return false;
        }
        var year, month, day;
        year = date8.substring(0, 4);
        month = date8.substring(4, 6);
        day = date8.substring(6, 8);
        var iaMonthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (year < 1700 || year > 2500) return false;
        if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0)
          iaMonthDays[1] = 29;
        if (month < 1 || month > 12) return false;
        if (day < 1 || day > iaMonthDays[month - 1]) return false;

        // calculate the sum of the products
        for (let i = 0; i < 17; i++) {
          lngProduct = lngProduct + varArray[i];
        }
        // calculate the check digit
        intCheckDigit = parityBit[lngProduct % 11];
        // check last digit
        if (varArray[17] != intCheckDigit) {
          return false;
        }
      }
      //length is 15
      else {
        //check date
        var date6 = idNumber.substring(6, 12);

        if (!/^[0-9]{6}$/.test(date6)) {
          return false;
        }
        var month, day, year;
        year = date6.substring(0, 2);
        month = date6.substring(2, 4);
        day = date6.substring(4, 6);
        if (!/^\d{2}$/.test(year)) return false;
        if (month < 1 || month > 12) return false;
        if (day < 1 || day > 31) return false;
      }
      return true;
    };
    if (str_idCard && check(str_idCard)) {
      if (undefined != sex) {
        var sexStr = undefined,
          tmp = 0;
        if (15 == str_idCard.length) {
          tmp = str_idCard.substring(str_idCard.length - 1, str_idCard.length);
        } else if (18 == str_idCard.length) {
          tmp = str_idCard.substr(str_idCard.length - 2, 1);
        }
        if (0 == tmp % 2) {
          sexStr = 0;
        } else {
          sexStr = 1;
        }

        if (sex != sexStr) return false;
      }
      return true;
    }
    return false;
  },
  //判断固定电话
  isMobile: function(str_data) {
    str_data = str_data || String(this);
    var length = str_data.length;
    return length == 11 && /^1\d{10}$/.test(str_data);
  },
  //判断手机号码
  isTelephone: function(str_data) {
    str_data = str_data || String(this);
    if (
      str_data.match(/^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/) ==
      null
    ) {
      return false;
    } else {
      return true;
    }
  }
};

const assemblyTree = function(dataList, pid) {
  const resultTree = []; //结果
  const itemMap = {};
  for (const item of dataList) {
    // console.log(item);
    const id = item.id;
    const parentId = item.parentId;
    if (!itemMap[id]) {
      itemMap[id] = { children: [] };
    }
    itemMap[id] = {
      ...item,
      children: itemMap[id]["children"]
    };
    const treeItem = itemMap[id];
    if (parentId === pid) {
      resultTree.push(treeItem);
    } else {
      if (!itemMap[parentId]) {
        itemMap[parentId] = {
          children: []
        };
      }
      itemMap[parentId].children.push(treeItem);
    }
  }
  console.log(resultTree)
  return resultTree;
};
const assemblyTree1 = function(data, parentId) {
  let tree = [];
  let temp;
  for (let i = 0; i < data.length; i++) {
    //循环数组
    if (data[i].parentid === parentId) {
      // 判断数组的parentId是否等于传进来的parentId
      let obj = data[i];
      temp = assemblyTree1(data, data[i].id); //如果等于就递归，将data作为源，id作为parentId
      if (temp.length > 0) {
        //如果得到的长度大于0
        obj.childOrgList = temp; //给它赋值
      }
      tree.push(obj); //push到新的数组中
    }
    if (!data[i].parentid) {
      console.log(data[i], "没有parentId");
    }
  }
  console.log('tree',tree)
  return tree;
};

const passWordMsg = {
  passWordRange: function (min, max) {
    console.log(min, max)
    return min + '-' + max + '位'
  },
  passWordContain: function (type, separator = '/') {
    const arr = type.split(',')
    const a = {
      1: '数字',
      2: '小写字母',
      3: '大写字母',
      4: '特殊符号'
    }
    return arr.map(item => a[item]).join(separator)
  },
  numToHan: function (num) {
    var arr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    return arr[num]
  }
}

export default {
  dict,
  check,
  state,
  assemblyTree,
  assemblyTree1,
  passWordMsg
};



// WEBPACK FOOTER //
// ./src/assets/js/global.js